import { render, staticRenderFns } from "./VAdministrationUserForm.vue?vue&type=template&id=6960bf9c&"
import script from "./VAdministrationUserForm.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationUserForm.vue?vue&type=script&lang=ts&"
import style0 from "./VAdministrationUserForm.vue?vue&type=style&index=0&id=6960bf9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports